<template>
  <article class="container-fluid">
    <AddStudent
      v-if="showAddStudent"
      :collections="collections"
      :hr-assistant-id="value.hrAssistantId"
      @add="addStudent"
      @cancel="$emit('update:showAddStudent', false)"
    />
    <div class="filter-container mt-2">
      <form novalidate>
        <div class="row">
          <div :class="['col-4 col-md-4']">
            <custom-input
              id="txtLocationName"
              v-model="searchField"
              placeholder="Escriba Nombre del Estudiante o Numero de SIE"
              icon="fa fa-search orange-icon"
              left-icon
            />
          </div>
          <div :class="['col-1 col-md-1']">
            <div>
              <action-button
                text="Buscar"
                variant="success"
                i="fas fa-search"
                :class="['px-4']"
                @click="searchStudents()"
              />
            </div>
          </div>
          <div class="col-2 col-md-7 mt-2 text-md-right">
            <span class="box-result-field-value">
              Total Estudiantes Asignados:
            </span>
            <span class="student-count">
              {{ collections.studentList.length }}
            </span>
          </div>
        </div>
      </form>
    </div>
    <AssignedStudentRow
      :student-list="collections.studentList"
      @remove="removeStudent"
    />
  </article>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import AssignedStudentRow from './components/AssignedStudentRow';
import AddStudent from './components/AddStudent';
import CustomInput from '@/components/common/CustomInput';
import ActionButton from '@/components/common/ActionButton';
import { getServiceAssistantsStudents } from '@/modules/service-assitant/api';

export default {
  name: 'Tab2AssignStudents',
  mixins: [alert],
  components: {
    AssignedStudentRow,
    AddStudent,
    CustomInput,
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    collections: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showAddStudent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchField: '',
    };
  },
  methods: {
    addStudent(student) {
      this.collections.studentList.unshift({
        id: student.id,
        sie: student.studentId,
        name: `${student.firstName} ${student.lastName}`,
        age: student.age,
        gade: student.mipeStudent.grade,
        impediment: student.mipeStudent.impedimentDescription,
        ubicationAlternative: student.mipeStudent.alternatePlacementDescription,
      });
    },
    removeStudent(student) {
      this.collections.studentList = this.collections.studentList.filter(
        (x) => x.id != student.id
      );
    },
    async searchStudents() {},
  },
  async mounted() {
    let params = {
      AssistantId: this.value.hrAssistantId,
    };
    await getServiceAssistantsStudents(params).then((res) => {
      res.data.data.forEach((student) => {
        this.collections.studentList.unshift({
          id: student.id,
          sie: student.sie,
          name: `${student.firstName} ${student.lastName}`,
          age: student.age,
          gade: student.grade,
          impediment: student.impedimentDescription,
          ubicationAlternative: student.ubicationDescription,
        });
      });
    });
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.filter-container {
  background-color: $gray;
  padding: 15px;
  border-radius: 5px;
}
.box-result-field-value {
  font-weight: bold;
}
.student-count {
  color: map.get($colors, 'orange');
}
</style>
